/**
 * Highlight hierarchial menu item
 */
(() => {

    window.addEventListener("scroll", () => {

        var section = document.querySelectorAll(".blocks .wp-block-heading");
        var sections = {};
        var i = 0;
        Array.prototype.forEach.call(section, function(e) {
            sections[e.id] = e.offsetTop - 50;
        });

        var scroll_position = document.documentElement.scrollTop || document.body.scrollTop;
        var is_after_first_item = false;
        var active_item = null;
        var sidebar = document.querySelector('.js-table-of-contents');
        for (i in sections) {

            if (sections[i] <= scroll_position) {
                is_after_first_item = true;

                active_item = { 'id': i, 'offsetTop': sections[i] };

                var current_active = document.querySelector('.table-of-contents .active');
                if (current_active !== null) {
                    current_active.classList.remove('active');
                }
            }
        }
        if (active_item !== null) {
            var hits = document.querySelector('.js-table-of-contents a[href="#' + active_item.id + '"]');
            var already_open = document.querySelector('.js-table-of-contents .open');
            if (already_open) {
                already_open.classList.remove('open');
            }

            if (hits) {

                hits.classList.add('active');

                var current_parent = hits.parentElement;
                while (current_parent && current_parent.tagName !== 'div') {
                    if (current_parent && current_parent.classList.contains('table-of-contents__item--parent')) {
                        current_parent.classList.add('open');
                        break;
                    }
                    current_parent = current_parent.parentElement;
                }

                // scroll to active element in menu
                if (sidebar && current_parent) {
                  sidebar.scrollTo(0, current_parent.offsetTop);
                }

            }
            active_item = null;
        }

        if (!is_after_first_item) {
            var current_active = document.querySelector('.js-table-of-contents .active');
            if (current_active !== null) {
                current_active.classList.remove('active');
            }
            var already_open = document.querySelector('.js-table-of-contents .open');
            if (already_open) {
                already_open.classList.remove('open');
            }
        }
    });

    const button = document.querySelector('.js-table-of-contents-button');
    if (button) {
        button.addEventListener('click', (e) => {
            const container = document.querySelector('.js-table-of-contents');
            if (container) {
                container.classList.toggle('is-open');
            }
        })
    }

    const links = document.querySelectorAll('.js-table-of-contents a');
    for (let i = 0; i < links.length; i++) {
        links[i].addEventListener('click', (e) => {
          setTimeout(() => {
            const container = document.querySelector('.js-table-of-contents');
            if (container) {
              container.classList.remove('is-open');
            }
            document.body.classList.remove('is-open-menu');
          }, 20);
        });
    }


  /**
   * Sticky header
   * With conditional not sticking
   */
  const tocMenu = document.querySelector(".js-table-of-contents");
  const headerLogo = document.querySelector(".js-site-header-branding");
  const adminBar = document.querySelector("#wpadminbar");
  if (tocMenu && headerLogo) {
    document.addEventListener("scroll", () => {

      const amountScrolled = document.documentElement.scrollTop;
      const scrollableHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const logoHeight = headerLogo.offsetHeight;
      if (adminBar) {
        logoHeight = logoHeight + adminBar.offsetHeight;
      }

      if (amountScrolled > logoHeight) {
        tocMenu.classList.add("table-of-contents--menu--stick");
      } else {
        tocMenu.classList.remove("table-of-contents--menu--stick");
      }
    });
  }

})();
